module.exports = __webpack_public_path__ + "static/22gde-1930060d6dc5753aa0eb0315660c0c77.gif";